import { api } from '../api.js';
import { state, setProject } from '../state.js';
import { humanTime } from '../ui.js';

// Проекты: переименование и удаление.
//
// Удаление живёт здесь, а не на самой странице проекта. Там оно стояло рядом с
// кнопкой «Начать собеседование» — то есть рядом с тем, что нажимают каждый
// день. Здесь оно там, куда заходят осознанно.

export const ProjectsSettings = {
  data() {
    return { confirmFor: 0, confirmName: '', removing: false, error: '' };
  },
  computed: {
    projects() { return state.projects; },
  },
  methods: {
    humanTime,

    ask(project) {
      this.confirmFor = this.confirmFor === project.id ? 0 : project.id;
      this.confirmName = '';
      this.error = '';
    },

    canRemove(project) { return this.confirmName.trim() === project.name; },

    /**
     * Удаление с вводом названия.
     *
     * Здесь уходит всё: собесы, записи, оценки, реестр вопросов, карточки
     * повторов — то, что копилось неделями и не восстанавливается ниоткуда.
     * Обычное «вы уверены?» на такое не годится: его жмут не читая.
     */
    async remove(project) {
      if (!this.canRemove(project)) return;
      this.removing = true;
      try {
        await api.del(`/api/projects/${project.id}`);
        state.projects = state.projects.filter((p) => p.id !== project.id);
        if (state.projectId === project.id) setProject(null);
        this.confirmFor = 0;
        this.confirmName = '';
      } catch (e) {
        this.error = e.message;
      } finally {
        this.removing = false;
      }
    },
  },
  template: `
    <div>
      <p class="err" v-if="error">{{ error }}</p>

      <div class="card" v-if="!projects.length">
        <p class="muted" style="margin:0">Проектов пока нет.</p>
      </div>

      <div class="card" v-for="p in projects" :key="p.id">
        <div class="row">
          <div style="flex:1;min-width:0">
            <b>{{ p.name }}</b>
            <div class="faint">{{ p.track }} · {{ p.grade }}</div>
          </div>
          <button class="ghost sm" @click="ask(p)">
            {{ confirmFor === p.id ? 'Отмена' : 'Удалить' }}
          </button>
        </div>

        <div class="danger-zone" v-if="confirmFor === p.id" style="margin-top:12px;padding:14px 16px;border-radius:10px;border:1px solid var(--bad-line)">
          <p class="note" style="margin-top:0">
            Уйдёт всё и навсегда: собесы, записи разговоров, оценки по темам,
            реестр заданных вопросов, карточки повторов и материалы.
            Восстановить это неоткуда.
          </p>
          <p class="note">Набери <b>{{ p.name }}</b>, чтобы подтвердить.</p>
          <div class="row wrap" style="gap:10px">
            <input v-model="confirmName" :placeholder="p.name" style="flex:1;min-width:180px"
                   @keydown.enter="canRemove(p) && remove(p)">
            <button class="danger" @click="remove(p)" :disabled="!canRemove(p) || removing">
              {{ removing ? 'Удаляю…' : 'Удалить навсегда' }}
            </button>
          </div>
        </div>
      </div>
    </div>`,
};
